import UsersGalleryGridSection from 'components/Community/UsersGallery/UsersGalleryGridSection/UsersGalleryGridSection';

export default UsersGalleryGridSection;
